import { useState } from 'react';
import LazyLoad from 'react-lazyload';

const VideoStyles = props => {
  const [isOpen, setIsOpen] = useState(false);

  const onToggle = () => {
    setIsOpen(value => !value);
  };

  return (
    <div className="flex flex-col gap-6 bg-white md:bg-purple-videoStyle md:py-48 md:px-24">
      <div
        className="cursor-pointer md:cursor-default flex flex-row items-center md:items-start gap-10 h-70 px-20 md:px-0 md:h-auto text-green-badge text-18 md:text-24 font-bold uppercase bg-purple-videoStyle md:bg-transparent"
        onClick={onToggle}
      >
        <svg
          className={`md:mt-10 max-w-min transform transition-transform ${isOpen ? 'rotate-90 md:rotate-0' : ''}`}
          style={{ maxWidth: '12px' }}
          width="12"
          height="14"
          viewBox="0 0 12 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M12 7L3.01142e-07 13.9282L9.06825e-07 0.0717964L12 7Z" fill="#09AF77" />
        </svg>
        <h3>{props.config.title}</h3>
      </div>
      <div className={`flex flex-col h-full justify-between mb-24 md:mb-0 px-20 md:px-0 ${!isOpen ? 'hidden md:flex' : ''}`}>
        <div className="h-full flex flex-col-reverse gap-6 md:flex-col justify-between">
          {props.config.description}
          <LazyLoad height={315} offset={100}>
            <iframe
              width="560"
              height="315"
              className={'w-full  ' + (props.config.extraClass ? props.config.extraClass : 'mt-24')}
              src={props.config.videoFrame}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </LazyLoad>
        </div>
        <div className="price-part flex flex-col lg:flex-row items-start lg:items-center gap-14 justify-between md:mt-48 mt-20 min-h-80 lg:min-h-48">
          <div className="flex flex-row gap-x-10 font-bold text-18 whitespace-nowrap">
            Starting from
            <span className="text-green-badge">{props.config.price}</span>
          </div>

          <div className="grid grid-cols-2 gap-16 w-full">
            <a
              className="whitespace-nowrap flex items-center justify-center get-offer-button bg-green-badge hover:bg-purple transition-all transition-400 text-white px-22  py-5 text-16 lg:text-16   rounded-md cursor-pointer"
              onClick={() => props.config.action(props.config.title, props.config.key)}
            >
              Order Now
            </a>
            <a
              rel="noopener noreferrer "
              href={props.config.btnLink}
              className="whitespace-nowrap flex items-center justify-center get-offer-button bg-purple hover:bg-green-badge transition-all transition-400 text-white px-22  py-5 text-16 lg:text-16   rounded-md cursor-pointer"
            >
              Learn More
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
export default VideoStyles;
